module.exports = __webpack_public_path__ + "img/heart.f99435ad.svg";